module.exports = __webpack_public_path__ + "img/coverPhoto.32d726ef.jpeg";